import { Typ33 } from '../Typ';
import styled, { css } from 'styled-components';

export const Button = styled.button`
  height: 36px;
  min-width: 80px;
  padding: 0 16px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  &:disabled {
    cursor: auto;
  }
  &:disabled > span {
    color: #607d8b;
  }
`;

const darkText = css`
  color: white;
  background-color: transparent;
`;

export const Label = styled(Typ33)`
  font-size: 14px;
  line-height: 24px;
  font-weight: normal;
  text-transform: uppercase;
  color: #007079;
  ${props => props.theme === 'dark' && darkText};
`;

export const Link = styled.a`
  height: 36px;
  min-width: 80px;
  padding: 0 16px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  &:disabled {
    cursor: auto;
  }
  &:disabled > span {
    color: #607d8b;
  }
`;
